import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form';

import * as classNames from 'classnames';
import * as Config from '../../configuration/consts';
 
import { ForumTag } from './ForumTag';
import { Search } from './Search';

import { Provider } from 'react-redux';

@withRouter
export class SideBar extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);
        this.state = { mobileShowSearch: undefined, mobileShowTags: undefined  }
        
        this.onLogout = this.onLogout.bind(this);
        this.onSubscribeForum = this.onSubscribeForum.bind(this);
        this.onSwitchForum = this.onSwitchForum.bind(this);
        this.onMobileShowTags = this.onMobileShowTags.bind(this);
        this.onMobileShowSearch = this.onMobileShowSearch.bind(this);
        this.onNotificationsClicked = this.onNotificationsClicked.bind(this);
        this.onGetForumClick = this.onGetForumClick.bind(this);
    }

    onGetForumClick(){
        this.props.getForumRequest(this.props.forum.id, false);
    }
    onSubscribeForum(){
        this.props.subscribeForum(this.props.forum.id);
    }
    onNotificationsClicked() {
        this.props.onNotificationsClicked();
    }
    onSwitchForum() {
        this.props.changeActiveTab(Config.SHOW_BOARDS);
    }

    onLogout() {
        this.props.logout(this.props.currentUser.email);
    }
    onMobileShowTags(tab) {
        this.setState({ mobileShowTags: !this.state.mobileShowTags });
    }

    onMobileShowSearch(tab) {
        this.setState({ mobileShowSearch: !this.state.mobileShowSearch });
    }
    
    render() {
        const { userRole, currentUser, forums, forum, activeTab, activeTag,searchPosts,searchResources,searchUsers,searchRequest,saveTagRequest,    ...props } = this.props;
        
        let isAdmin = userRole == Config.ROLE_ADMIN;
        let searchTerm = "";
        
        let tagTitle = activeTab == Config.SHOW_FORUM ? "topic" : activeTab == Config.SHOW_RESOURCES ? "folder" : "";

        let showBoardsButton = activeTab != Config.SHOW_BOARDS && ((forums && forums.length > 1) || isAdmin);
        
        let myBoards = showBoardsButton ? <button type="button" className="btn btn-default btn-block" onClick={this.onSwitchForum}>MY BOARDS</button> : undefined;
        //let subscribe = forum ? <button type="button" className={classNames("btn btn-block", {"btn-secondary": forum.subscribed, " btn-primary": !forum.subscribed})} onClick={this.onSubscribeForum}>{forum.subscribed ? "UNSUBSCRIBE" : "SUBSCRIBE"}</button>: undefined;
        let mobileMyBoards = showBoardsButton ? <button className="btn btn-block btn-default" onClick={this.onSwitchForum}><i className="fa fa-random fa-lg"></i></button> : undefined;

        let type = activeTab == Config.SHOW_FORUM ? Config.POST : activeTab == Config.SHOW_RESOURCES ? Config.RESOURCE : undefined;
        
        let activeFilter = forum && forum.activeTags ? forum.activeTags.find(i => i.type === type) : undefined;
        
        let searchCallback = searchPosts;
        switch(activeTab){
            case Config.SHOW_FORUM:
                searchCallback = searchPosts;
                searchTerm = this.props.forum && this.props.forum.search ? this.props.forum.search.post : undefined;
            break;
            case Config.SHOW_RESOURCES:
                searchTerm = this.props.forum && this.props.forum.search ? this.props.forum.search.resource : undefined;
                searchCallback = searchResources;
            break;
            case Config.SHOW_MEMBERS:
                searchTerm = this.props.forum && this.props.forum.search ? this.props.forum.search.member : undefined;
                searchCallback = searchUsers;
            break;
            case Config.SHOW_BOARDS:
                searchCallback = searchRequest;
            break;
        }
        
        let addTagButton = isAdmin && type ? <ForumTag title={tagTitle} forum={forum} saveTagRequest={saveTagRequest} type={type} activeTag={activeTag}/> : undefined;
        let filters = undefined;
        if (forum && forum.tags && type) {
            let sortedTags = forum.tags ? forum.tags.sort((a, b) => {
                if(a.rank > b.rank){
                    return 1;
                } else if (a.rank < b.rank) {
                    return -1;
                } else {
                    return 0;
                }
            }) : undefined;

            filters = sortedTags.map((item, index) => {
                let activeItem = (activeFilter && activeFilter.id === item.id && activeFilter.type === item.type);
                return (item.type === type && item.pinned) ?
                    <ForumTag key={index} type={type} filterItem={item} title={tagTitle}
                        activeTag={activeTag} active={activeItem} activeFilter={activeFilter}
                        forum={forum} saveTagRequest={saveTagRequest}  isAdmin={isAdmin}
                        /> : undefined;
            });
            let activeItem = (!activeFilter || !activeFilter.id);
            filters = filters ? <div className="btn-group-vertical btn-block" role="group" aria-label="Filters">
                <ForumTag key={0} type={type} filterItem={{ name: Config.VIEW_ALL, id: undefined, type: type }} 
                    activeTag={activeTag} active={activeItem} activeFilter={activeFilter}
                    forum={forum} saveTagRequest={saveTagRequest} isAdmin={isAdmin}
                />
                {filters}
            </div> : undefined;

            filters = <div>{filters}{addTagButton}<hr /></div>
        }
        let backToBoard = this.props.singlePostView ? <button type="button" className="btn btn-primary mb-4 btn-block" onClick={this.onGetForumClick}>BACK TO FORUM</button> : undefined;
        let search = <Search text={searchTerm} search={searchCallback} forum={forum} currentUser={currentUser}/>;
        let logout = <button type="button" className="btn btn-default btn-block" onClick={this.onLogout}>LOGOUT</button>;

        return (<div className="col-12 col-md-3 pl-md-0 mb-3 discussion-board sidebar">
                    <div className="sidebar-actions">
                        <div className="btn-group btn-block">
                            <button className="btn btn-block btn-default" onClick={this.onMobileShowSearch}><i className="fa fa-search fa-lg"></i></button>
                            <button className="btn btn-block btn-default" onClick={this.onMobileShowTags}><i className="fa fa-bars fa-lg"></i></button>
                            {mobileMyBoards}
                            <button className="btn btn-block btn-default" onClick={this.onLogout}><i className="fa fa-sign-out fa-lg"></i></button>
                        </div>
                        <div className="mt-2">
                        {this.state.mobileShowSearch ? search : undefined }
                        {this.state.mobileShowTags ? filters : undefined }
                        </div>
                    </div>
                    <div className="sidebar-actions-lg">    
                        {search}
                        <hr/>
                        {backToBoard ? backToBoard : filters}
                        {myBoards}
                        {logout}
                    </div>
                </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/SideBar.tsx